import { api } from "../AxiosInstance";
import { Job, JobOrder, TripContainer } from "../interfaces/job.interface";
import { urlQueryBuilder } from "../utils/urlQueryBuilder";

interface ForceEndTripRequest {
  tripId: number;
  reason: string;
  comment: string;
}

interface ViewImagesRequest {
  tripId: number;
  position?: string;
}

const JobService = {
  getMyJobs: async (
    queryParams: {
      status?: string;
      skip?: number;
      limit?: number;
    } = {}
  ) => {
    try {
      const queryString = urlQueryBuilder(queryParams);
      const response = await api.get(
        `/job${queryString ? `?${queryString}` : ""}`
      );
      return response;
      // return response.data; // Return only the data payload
    } catch (error) {
      console.error("Error getMyJobs:", error);
      throw error; // Re-throw error for global handling if necessary
    }
  },

  createJob: async (job: Job) => {
    try {
      const response = await api.post("/job", job);
      return response;
    } catch (error) {
      console.error("Error createJob:", error);
      throw error; // Re-throw error for global handling if necessary
    }
  },

  updateJob: async (jobOrder: Job) => {
    try {
      const response = await api.post("/job/edit-job", jobOrder);
      return response;
    } catch (error) {
      console.error("Error updateJob:", error);
      throw error;
    }
  },

  assignContainers: async (containersList: TripContainer[]) => {
    try {
      const response = await api.put(`/job/edit-trip`, containersList);
      return response;
    } catch (error) {
      console.error("Error assignContainers:", error);
      throw error;
    }
  },

  getJobDetails: async (jobId: number) => {
    try {
      const response = await api.get("/job/jobId?jobId=" + jobId);
      return response;
    } catch (error) {
      console.error("Error getJobDetails:", error);
      throw error;
    }
  },

  trackDriver: async (driverId: number) => {
    try {
      const response = await api.get(
        "/job/driver-location?driverId=" + driverId
      );
      return response;
    } catch (error) {
      console.error("Error trackDriver:", error);
      throw error;
    }
  },

  getJobHistory: async (
    queryParams: {
      status?: string;
      skip?: number;
      limit?: number;
      jobCode?: string;
      from?: number | null;
      to?: number | null;
      signal?: AbortSignal;
    } = {}
  ) => {
    try {
      const { signal, ...params } = queryParams;
      const queryString = urlQueryBuilder(params);
      const response = await api.get(
        `/job-history${queryString ? `?${queryString}` : ""}`,
        { signal }
      );
      return response;
    } catch (error) {
      console.error("Error getJobHistory:", error);
      throw error;
    }
  },

  getJobHistoryStats: async () => {
    try {
      const response = await api.get("/job-history/trip-stats");
      return response.data;
    } catch (error) {
      console.error("Error getJobHistoryStats:", error);
      throw error;
    }
  },

  dispatchJob: async (jobId: number) => {
    try {
      const response = await api.put(`/job/available`, {
        jobIds: [jobId],
      });
      return response;
    } catch (error) {
      console.error("Error in dispatchJob:", error);
      throw error;
    }
  },

  cancelJob: async (jobId: number) => {
    try {
      const response = await api.get(
        `/job/change-status?jobId=${jobId}&status=CANCELLED`
      );
      return response;
    } catch (error) {
      console.error("Error in cancelJob:", error);
      throw error;
    }
  },

  deleteJob: async (jobId: number) => {
    try {
      const response = await api.put(`/job/delete-job?jobId=${jobId}`);
      return response;
    } catch (error) {
      console.error("Error in deleteJob:", error);
      throw error;
    }
  },

  getActiveTripStats: async () => {
    try {
      const response = await api.get("/job/active-trip-stats");
      return response;
    } catch (error) {
      console.error("Error getActiveTripStats:", error);
      throw error;
    }
  },

  getActiveTrips: async (
    queryParams: {
      status?: string;
      skip?: number;
      limit?: number;
      jobCode?: string;
      from?: number | null;
      to?: number | null;
    } = {}
  ) => {
    try {
      const queryString = urlQueryBuilder(queryParams);
      const response = await api.get(
        `/job/active-trips${queryString ? `?${queryString}` : ""}`
      );
      return response;
      // return response.data; // Return only the data payload
    } catch (error) {
      console.error("Error getJobHistory:", error);
      throw error; // Re-throw error for global handling if necessary
    }
  },

  forceEndTrip: async (request: ForceEndTripRequest) => {
    try {
      const response = await api.post("/job/force-end-trip", request);
      return response;
    } catch (error) {
      console.error("Error in forceEndTrip:", error);
      throw error;
    }
  },




    viewImages: async (
    queryParams: {
      tripId?: number;
      position?: string;
    } = {}
  ) => {
    try {
      const queryString = urlQueryBuilder(queryParams);
      const response = await api.get(
        `trip/image-paths${queryString ? `?${queryString}` : ""}`
      );
      return response;
      // return response.data; // Return only the data payload
    } catch (error) {
      console.error("Error getJobHistory:", error);
      throw error; // Re-throw error for global handling if necessary
    }
  },
};

export default JobService;
